export default {
  relatedPosts: 'Схожі пости:'
}
